import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import './PaymentRedirect.css';

const PaymentRedirect = () => {
  const { state } = useLocation();
  const grandTotal = state?.grandTotal;
  const name = state?.form?.fullName || 'Customer';

  return (
    <div className="pr-page">
      <div className="pr-card">
        <FaCheckCircle className="pr-icon" />
        <h1>Order Placed Successfully!</h1>
        <p className="pr-name">
          Thank you, <strong>{name}</strong>!
        </p>
        {grandTotal && (
          <p className="pr-amount">
            Amount to pay: <strong>₹{grandTotal.toFixed(2)}</strong>
          </p>
        )}
        <div className="pr-gateway-note">
          <p>You would now be redirected to our secure payment gateway.</p>
          <p className="pr-sub">This is currently in demo mode — no actual payment is processed.</p>
        </div>
        <div className="pr-actions">
          <Link to="/our-menu" className="btn-primary">
            CONTINUE SHOPPING
          </Link>
          <Link to="/" className="pr-home-link">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentRedirect;
